const sections = [
    {
        name: 'Home',
        ref: '#'
    },
    {
        name: 'About',
        ref: '#about'
    },
    {
        name: 'Skills',
        ref: '#skills'
    },
    {
        name: 'Portfolio',
        ref: '#portfolio'
    },
    {
        name: 'Contact',
        ref: '#contact'
    }
];

export default sections;



// WEBPACK FOOTER //
// ./src/data/sections.js